"use client";

import { Loader2 } from "lucide-react";

interface ButtonLoaderProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizeClasses = {
  sm: "w-4 h-4",
  md: "w-5 h-5",
  lg: "w-6 h-6",
};

export function ButtonLoader({ size = "md", className = "" }: ButtonLoaderProps) {
  return (
    <Loader2 
      className={`animate-spin ${sizeClasses[size]} ${className}`}
      aria-hidden="true"
    />
  );
}
